export const ENCOUNTER = { entityTypeId: 114, entityTypeName: "Encounter" };
export const DIAGNOSIS = { entityTypeId: 115, entityTypeName: "Diagnosis" };
